import { httpV2 } from "@/api";
import Qs from "qs";

/**
 * Consulta no back-end para obter uma lista de alterações de limite e
 * notificações de uma tendência de uma componente de frequência,
 * filtrado pela data de ínicio, fim e a empresa do usuário que faz a requisição.
 * @param startDateTime - String da data de inicio da consulta em UTC.
 * @param endDateTime - String da data de fim da consulta em UTC.
 * @returns Lista de logs de uma empresa.
 */
const Get = function(startDateTime  = "", endDateTime = "")
{
	const queryParms = {};
	queryParms.startDateTime = startDateTime;
	queryParms.endDateTime = endDateTime;

	return httpV2.get("/FrequencyTrendLimitNotificationLogs",
		{
			params:           queryParms,
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

export default { Get };